import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import ContactsPeopleIconSVG from "../../../resources/svg/ContactsPeopleIconSVG";
import { WorkDTO } from "../../../../domain/models/dto/WorkDTO";
import ApplicationCard from "./ApplicationCard";
import { getSelectedExecutorsCount, isExpressWork } from "../../../../slices/works-slice";
import PaginatedList from "../../../resources/components/PaginatedList";

interface ApplicationsListProps {
    work: WorkDTO;
    uploadApplicationsCallback: () => Promise<void>;
    deleteApplicationCallback: () => void;
}

const ApplicationsList: FC<ApplicationsListProps> = (props) => {
    const { t } = useTranslation();
    const [isAcceptOrDeclineAvailable, setAcceptOrDeclineAvailable] = useState(false);

    if (isExpressWork(props.work)) {
        return <></>;
    }

    return (
        <div className="relative flex flex-col dmin2:w-[737px]">
            <div className="flex tmax4:flex-col justify-between mb-9 dmax2:mb-6">
                <h2 className="H24B dmax2:H20B text-textWhite tmax4:mb-4">
                    {t("work.applications", { applications: props.work.applications?.totalRows || 0 })}
                </h2>
                <div className="flex justify-center items-center bg-accentGreen rounded-[30px] tmax4:w-full py-2.5 tmax4:py-1.5 px-4">
                    <ContactsPeopleIconSVG className="text-textWhite w-6 h-6 dmax2:w-4 dmax2:h-4 mr-3 dmax2:mr-1.5" />
                    <span className="H16 dmax2:H14 text-textWhite">
                        {t("work.workersSelected", {
                            current: getSelectedExecutorsCount(props.work),
                            total: props.work.workersAmount,
                        })}
                    </span>
                </div>
            </div>
            <PaginatedList
                entities={props.work.applications}
                emptyEntitiesContent={<p className="H24 dmax2:H20 text-textFaded">{t("work.emptyApplications")}</p>}
                uploadCallback={props.uploadApplicationsCallback}
                getItemElement={(application) => (
                    <ApplicationCard
                        key={`application-${application.id}`}
                        work={props.work}
                        application={application}
                        deleteApplicationCallback={props.deleteApplicationCallback}
                        isAcceptOrDeclineAvailable={isAcceptOrDeclineAvailable}
                        setAcceptOrDeclineAvailable={setAcceptOrDeclineAvailable}
                    />
                )}
            />
        </div>
    );
};

export default ApplicationsList;
